import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { ReferenceSchema } from '../../../../expressions/validation/ReferenceSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema.ts';
import { CommonContainerWidgetConfigSchema } from '../../containers/common/CommonContainerWidgetConfigSchema.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IRepeatableWidget } from './IRepeatableWidget.ts';

export const RepeatableWidgetConfigSchema: yup.ObjectSchema<IRepeatableWidget> =
  CommonInputWidgetConfigSchema.concat(CommonContainerWidgetConfigSchema)
    .shape({
      type: yup.string().exact(WidgetType.Repeatable).required(),
      description: RichTextAdvancedSchema.optional().label('Descrizione'),
      showInSummary: yup.boolean().default(false).label('Mostra nel riepilogo'),
      summaryReference: ReferenceSchema.label('Etichetta nel riepilogo').when(
        ['showInSummary'],
        ([showInSummary], schema) =>
          showInSummary ? schema.required() : schema.notRequired().strip(),
      ),
      layout: BaseLayoutSchema.shape({
        showAtLeastOne: yup
          .boolean()
          .required()
          .default(false)
          .label('Mostra almeno un elemento'),
        hideNumberItem: yup
          .boolean()
          .required()
          .default(false)
          .label('Nascondi numero della lista'),
        hideBorder: yup
          .boolean()
          .required()
          .default(false)
          .label('Nascondi bordo della lista'),
        buttonText: yup
          .string()
          .optional()
          .default('Aggiungi')
          .label('Testo del pulsante aggiungi'),
        hideAddButton: yup
          .boolean()
          .required()
          .default(false)
          .label('Nascondi pulsante aggiungi'),
        hideRemoveButton: yup
          .boolean()
          .required()
          .default(false)
          .label('Nascondi pulsante rimuovi'),
        showConfirmDelete: yup
          .boolean()
          .required()
          .default(false)
          .label('Mostra conferma di eliminazione'),
        confirmDeleteTitle: yup
          .string()
          .label('Titolo conferma eliminazione')
          .when('showConfirmDelete', {
            is: true,
            then: schema => schema.required(),
            otherwise: schema => schema.optional(),
          })
          .default("Eliminare l'elemento?"),
        confirmDeleteButtonLabel: yup
          .string()
          .label('Testo pulsante conferma eliminazione')
          .when('showConfirmDelete', {
            is: true,
            then: schema => schema.required(),
            otherwise: schema => schema.optional(),
          })
          .default('Elimina'),
        cancelDeleteButtonLabel: yup
          .string()
          .label('Testo pulsante annulla eliminazione')
          .when('showConfirmDelete', {
            is: true,
            then: schema => schema.required(),
            otherwise: schema => schema.optional(),
          })
          .default('Annulla'),
      })
        .required()
        .noUnknown(),
    })
    .required()
    .noUnknown();
